import React, { useMemo } from 'react'
import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'

import BaseLayout from '../../common/components/BaseLayout'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import Compass from '../../map/components/Compass'

import PowerOutagesLayer from '../../map/components/PowerOutagesLayer'

const MainLayout = () => {
  useUserPreferencesFetch()

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      left: 460,
      right: 10,
      bottom: 20,
    }),
    []
  )

  return (
    <BaseLayout title="Power Outages">
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Compass position="bottom-right" />
        <Zoom position="bottom-right" />
        <PowerOutagesLayer />
      </Map>
    </BaseLayout>
  )
}

export default MainLayout
